import Layout from '@/components/layout/Layout.vue'
import { getProjects,updateProjectByField } from '@/api/project'
import CreateAnchorForm from '@/views/sys/advertiser/anchor/create/Create.vue'

export default {
    components: {
        Layout,
        CreateAnchorForm,
    },
    props: {
        showProjectPage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            columns: [
                { title: '项目ID', dataIndex: 'project_id' },
                { width:220,title: '项目名称', dataIndex: 'name' },
                { title: '广告项目状态', dataIndex: 'status_name', formatter: 'empty' },
                { title: '出价',dataIndex: 'show_bid', customRender: show_bid => {
                    return show_bid || '-'
                }},
                { title: '预算',dataIndex:'', scopedSlots: { customRender: 'budget' } },
                { title: '创建时间', dataIndex: 'project_create_time' },
                { title: '更新时间', dataIndex: 'project_modify_time' },
                { title: '操作状态',dataIndex:'', scopedSlots: { customRender: 'opt_status' } },
            ],
            queryParam: {},
            showCreateForm: false,
            anchorModel: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize,
                id: this.model.id,
            })
            this.$helper.buildDateRangeParams(json, 'date')
            getProjects(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showProjectPage', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('AdvertiserController', route)
        },
        createAnchor() {
            //过滤没有资产的广告主
            if (!this.model.juliang_apps || this.model.juliang_apps.length < 1) {
                return this.$message.error('请先创建小程序资产！')
            }
            this.anchorModel = {
                anchor_type: 'APP_INTERNET_SERVICE', //样式:网服
                net_service_type: 'MICRO_APP', //推广内容：微信小程序
                ios_anchor_title: null,
                android_anchor_title: null,
                app_description: null, //APP详情
                app_tags: [null, null, null],
                guide_text: null,
                advertisers: [
                    { advertiser_id: this.model.id, out_id: this.model.out_id, advertiser_name: this.model.name, apps: this.model.juliang_apps ? this.model.juliang_apps : [] }
                ],
            }
            this.showCreateForm = true
        },
        updateProject(id, field,  value) {
            this.loading = true
            const data = {
                advertiser_id: this.model.id,
                id: id,
                field: field,
                value: value
            }
            updateProjectByField(data).then(res => {
                const actionType = value === 'ENABLE' ? '暂停项目' : '启用项目'
                this.$message.destroy()
                if (res.code === 0) {
                    this.$message.success(actionType+'成功')
                } else {
                    this.model.opt_status =  this.model.opt_status === 'ENABLE' ? 'DISABLE' : 'ENABLE'
                }
                this.refresh()
            }).catch(() => {
                this.loading = false
                this.data = []
                this.refresh()
            })
        },

    }
}
